import { Button, Flex, Heading, HStack, Text } from '@chakra-ui/react';
import { FaPlus, FaRegTrashAlt } from 'react-icons/fa';
import { LuPencil } from 'react-icons/lu';
import { usePermissions } from 'shared/hooks/usePermissions';
interface TittleBlockButton {
  type: 'edit' | 'delete' | 'add';
  variant?: string;
  color?: string;
  icon?: React.ReactNode;
  onClick: () => void;
  text?: string;
  isDisabled?: boolean;
  permission?: string;
}
interface ContractDetailsBlockProps {
  title?: string;
  children: React.ReactNode;
  removeSeparator?: boolean;
  loading?: boolean;
  vertical?: boolean;
  rightButtons?: TittleBlockButton[];
  rightElement?: React.ReactNode;
}
const ContractDetailsBlock = ({
  children,
  title,
  removeSeparator = false,
  loading,
  vertical = false,
  rightButtons,
  rightElement,
}: ContractDetailsBlockProps) => {
  const { d } = usePermissions();

  rightButtons = rightButtons?.map((button) => {
    if (button.type === 'edit') {
      button.variant = 'plainIcon';
      button.color = 'yPrimary.600';
      button.icon = <LuPencil size="13" />;
    } else if (button.type == 'delete') {
      button.variant = 'plainIcon';
      button.color = 'yRed.600';
      button.icon = <FaRegTrashAlt size="13" />;
    } else if (button.type == 'add') {
      button.variant = 'plainIcon';
      button.color = 'yPrimary.600';
      button.icon = <FaPlus size="13" />;
    }
    return button;
  });
  return (
    <>
      {title && (
        <HStack pt="20px" justify={'space-between'} align="center">
          <Heading variant="small" opacity={loading ? '.3' : ''}>
            {title}
          </Heading>
          <HStack>
            {rightElement}
            {!rightElement &&
              rightButtons?.map((button, index) => (
                <Button
                  key={index}
                  variant={button.variant}
                  size="xs"
                  isDisabled={
                    loading ||
                    button.isDisabled ||
                    (button.permission ? d(button.permission) : false)
                  }
                  color={button.color}
                  onClick={() => button.onClick()}
                >
                  {button.icon}
                  {button.text && (
                    <Text
                      size="xs"
                      color="yPrimary.600"
                      fontWeight={500}
                      variant="regular"
                    >
                      {button.text}
                    </Text>
                  )}
                </Button>
              ))}
          </HStack>
        </HStack>
      )}
      <Flex
        w="100%"
        direction={vertical ? 'column' : 'row'}
        borderBottom={removeSeparator ? '' : '1px solid'}
        borderColor="yGray.100"
        align={'center'}
        pb="6"
        pt="6"
      >
        {children}
      </Flex>
    </>
  );
};
export default ContractDetailsBlock;
